import { Capacitor } from '@capacitor/core';

/**
 * Initialize native app features. Call once on app startup.
 * Safe to call on web — all operations are gated behind platform checks.
 */
export const initNativeApp = async () => {
  if (!Capacitor.isNativePlatform()) {
    return;
  }

  // Enable native-app CSS (safe area padding, etc.)
  document.body.classList.add('native-app');

  // Configure status bar
  try {
    const { StatusBar, Style } = await import('@capacitor/status-bar');
    await StatusBar.setStyle({ style: Style.Light });

    if (Capacitor.getPlatform() === 'android') {
      await StatusBar.setBackgroundColor({ color: '#1E40AF' });
    }
  } catch (e) {
    console.warn('StatusBar plugin not available:', e);
  }

  // Start network monitoring
  try {
    const { Network } = await import('@capacitor/network');

    Network.addListener('networkStatusChange', (status) => {
      if (!status.connected) {
        document.body.classList.add('offline');
      } else {
        document.body.classList.remove('offline');
      }
    });

    // Check initial status
    const status = await Network.getStatus();
    if (!status.connected) {
      document.body.classList.add('offline');
    }
  } catch (e) {
    console.warn('Network plugin not available:', e);
  }
};
